<template>
    <span>
        <font-awesome-icon
            v-if="value"
            :icon="['fas', 'circle-check']"
            class="text-success yes-no-cell-size"
        ></font-awesome-icon>
        <font-awesome-icon
            v-else
            :icon="[plain ? 'far' : 'fas', plain ? 'circle' : 'times-circle']"
            class="text-danger yes-no-cell-size"
            v-bind:class="{ 'invisible': invisible}"
        ></font-awesome-icon>
    </span>
</template>

<script>
    export default {
        data() {
            return {
                value: false,
            };
        },
        created() {
            this.value = this.params.value;
            this.plain = this.params.plain || false;
            this.invisible = this.params.invisible || false;
        },
    }
</script>

<style lang="css" scoped>
.yes-no-cell-size {
    font-size: 1.4em;
}
</style>